// mobile slider
$(document).ready(function () {
  $('.mobile-slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      arrows: false,
      centerMode: true,
      centerPadding: '30px',
      infinite: false,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            centerPadding: '30px',
          }
        }
      ]
  });
});

// Desktop scroll handle
document.addEventListener('DOMContentLoaded', function() {
  const scrollableBlock = document.getElementById('scrollable-block');
    const body = document.body;

  if (scrollableBlock) {
    let currentScrollIndex = scrollableBlock.children.length - 1; // Start at the bottom

    // Calculate total height of scrollable block
    const totalHeight = scrollableBlock.scrollHeight;

    // Calculate height of each scrollable item
    const itemHeight = totalHeight / scrollableBlock.children.length;

    // Calculate the position to scroll to
    const scrollToPosition = currentScrollIndex * itemHeight;

    // Scroll to the bottom initially
    scrollableBlock.scrollTo({
      top: scrollToPosition,
      behavior: 'auto'
    });

    let isScrolling = false;
    let scrollTimer;

    // Check if the scrollable block is in viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const scrollbarWidth = window.innerWidth - document.body.clientWidth;

          body.style.overflow = 'hidden';
          body.style.marginRight = `${scrollbarWidth}px`;

          // Calculate the top position of the section
          const sectionTop = scrollableBlock.offsetTop;
          // Calculate the height of the section
          const sectionHeight = scrollableBlock.offsetHeight;
          // Get the viewport height
          const viewportHeight = window.innerHeight;
          // Calculate the scroll position to align the section bottom with the viewport bottom
          const scrollToPosition = sectionTop + sectionHeight - viewportHeight;

          setTimeout(() => {
            window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
          }, 100);

          scrollableBlock.classList.add('scrollable');

          setTimeout(() => {
            body.style.overflow = 'auto';
            body.style.marginRight = 0;
            window.addEventListener('wheel', handleWheel, { passive: false });
          }, 300);
        } else {
          body.style.overflow = 'auto';
          window.removeEventListener('wheel', handleWheel);
          scrollableBlock.classList.remove('scrollable');
        }
      });
    }, { threshold: 0.8 });

    // Start observing the scrollable block
    observer.observe(scrollableBlock);

    function handleWheel(event) {
      event.preventDefault(); // Prevent default scroll behavior

      if (!isScrolling) {
        isScrolling = true;

      // Calculate direction of scroll
      const direction = event.deltaY > 0 ? -1 : 1;

      // Update currentScrollIndex based on direction
      currentScrollIndex += direction;

      // Keep currentScrollIndex within bounds
      if (currentScrollIndex < 0) {
        currentScrollIndex = 0;
      } else if (currentScrollIndex >= scrollableBlock.children.length) {
        currentScrollIndex = scrollableBlock.children.length - 1;
      }

      // Calculate the position to scroll to
      const scrollToPosition = currentScrollIndex * itemHeight;

        const jQueryScrollableBlock = $('.scrollable-block');
        jQueryScrollableBlock.animate({
          scrollTop: scrollToPosition
        }, 1200, 'swing');

      // Check if we're at the top or bottom after scroll
      const isAtTop = scrollableBlock.scrollTop === 0;
      const isAtBottom = scrollableBlock.scrollTop + scrollableBlock.clientHeight >= scrollableBlock.scrollHeight;

      if (isAtTop && direction === -1) {
        event.preventDefault();
                    window.scrollBy(0, 60);
                    isScrolling = false; // Allow fast scrolling at the top
                    body.style.overflow = 'auto';
                    window.removeEventListener('wheel', handleWheel);
                    scrollableBlock.classList.remove('scrollable');
      }
      if (isAtBottom && direction === 1) {
        event.preventDefault();
                    window.scrollBy(0, -60);
                    isScrolling = false; // Allow fast scrolling at the bottom
                    body.style.overflow = 'auto';
                }

                // Set a timer to reset isScrolling after 400ms
                scrollTimer = setTimeout(function () {
                    isScrolling = false;
                    clearTimeout(scrollTimer);
                }, 400); // Adjust this value as needed for your desired delay
      }
    }
  }
});